import styled from 'styled-components';

export const ColorDot = styled.span<{ color: string }>`
	background: ${({ color }) => color};
	border-radius: 50%;
	display: inline-block;
	height: 8px;
	width: 8px;
	margin-right: 10px;
`;
